import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-form-validator-core';
import { getDate } from '../../../utils/helper';
import Header from '../../layout/Header';
import TextValidator from '../../partial/TextValidator';
import { createCustomer, getCustomerGroupDataBySelectValue, updateCustomer, updateSponsers } from '../campaigns/services';
import { getCustomerGroupById, getCustomerGroupList, getSponserById } from '../../../actions/campaigns';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import Paginated from './Paginated';
import { COLUMNS } from './column';
import { createSponsers, getSponserData } from '../../../actions/auth';
import { decrypt } from '../../../utils/encodingdecoding';
import { backIcon2 } from '../../../Image/Index';

function CreateSponser() {


    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const getId = location.state
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        status: false,
        type: "Default",
        code: "",
        tags: [""],
        account: {
            accountDetails: [
                {
                    type: "point",
                    accounttype: "",
                    limit: 0,
                    used: 0,
                    balance: 0,
                }
            ]
        },
        isTest: false,
        isSponsorLimitChecked: false,
        merchantId: [decrypt(localStorage.getItem("merchantcode"))],
    });
    const { name, status, isTest, isSponsorLimitChecked } = formData;

    const onChange = (e) => {
        const { name, value } = e.target;
        if (name === 'limit') {
            setFormData(prev => ({
                ...prev,
                account: {
                    ...prev.account,
                    accountDetails: prev.account.accountDetails.map((detail, index) =>
                        index === 0 ? {
                            ...detail, [name]: Number(value),
                            ...(name === 'limit' ? { balance: Number(value) } : {})
                        } : detail
                    )
                }
            }));
        } else {
            setFormData({ ...formData, ...{ [e.target.name]: e.target.value } });
        }
    };



    const onSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        if (getId) {
            const response = await updateSponsers(token?.access_token, getId, formData);
            if (response?.message === "Record Updated Successfully.") {
                swal({
                    position: "center",
                    icon: "success",
                    title: "Sponser Updated Successfully.",
                    showConfirmButton: false,
                    timer: 2000,
                });
                setFormData({
                    name: "",
                    status: false,
                    type: "Default",
                    code: "",
                    tags: [""],
                    account: {
                        accountDetails: [
                            {
                                type: "point",
                                accounttype: "",
                                limit: 0,
                                used: 0,
                                balance: 0,
                            }
                        ]
                    },
                    isTest: false,
                    isSponsorLimitChecked: false,
                });
                navigate("/sponser")
            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: response?.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } else {
            const response = await createSponsers(token?.access_token, formData);
            if (response?.message === "Record Created Successfully.") {
                swal({
                    position: "center",
                    icon: "success",
                    title: "Sponser Created Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                setFormData({
                    name: "",
                    status: false,
                    type: "Default",
                    code: "",
                    tags: [""],
                    account: {
                        accountDetails: [
                            {
                                type: "point",
                                accounttype: "",
                                limit: 0,
                                used: 0,
                                balance: 0,
                            }
                        ]
                    },
                    isTest: false,
                    isSponsorLimitChecked: false,
                });
                navigate("/sponser")
            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: response?.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        }
        setLoader(false);
    };

    useEffect(() => {
        if (getId) {
            setLoader(true)
            const token = JSON.parse(localStorage.getItem("token_gen"));
            getSponserById(token?.access_token, getId).then((res) => {
                window.scrollTo(0, 0);
                const { name, status, isTest, isSponsorLimitChecked, code,account } = res?.data;
                setFormData((prevState) => ({
                    ...prevState,
                    name: name,
                    status: status,
                    type: "Default",
                    code: code,
                    tags: [""],
                    account: account,
                    isTest: isTest,
                    isSponsorLimitChecked: isSponsorLimitChecked,
                }));
                setLoader(false)
            }).catch(() => {
                setLoader(false)
            })
        }
    }, [])

    const span_cbox = {
        display: "inline-block",
        marginBottom: "5px"
    }


    const handleToggle = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.checked,
        }));
    };
    console.log(formData)

    function validateNumbersOnly(event) {
        const input = event.target.value;
        const regex = /^[0-9]*$/;

        if (!regex.test(input)) {
            event.target.value = input.replace(/[^0-9]/g, "");
        }
    }
    return (
        <div>
            <Header name={"Sponser"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__profileSettingsMain">
                        <div className="dashboard__heading">
                            <div className="dashboard__headingLeft">
                                <div className="dashboard__headingBackLink">
                                    <Link to="" onClick={() => navigate(-1)}>
                                        <img src={backIcon2} alt="" />
                                        <div className="dashboard__headingContent">
                                            <h3>Sponser</h3>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard__profileSettingsBox">
                            <ValidatorForm onSubmit={onSubmit} className="dashboard__customerViewMain">
                                <div className="dashboard__transactionsCard">
                                    <div className="dashboard__header">
                                        <div className="dashboard__left">
                                            {getId ? (
                                                <h4 id='transction_list'>Update Sponser</h4>
                                            ) : (
                                                <h4 id='transction_list'>Create Sponser</h4>
                                            )}

                                        </div>
                                    </div>
                                    <div className='dashboard__customerViewCard'>

                                        <div className="row">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                                <span style={span_cbox}>Name</span>
                                                <TextValidator className="form-control" validators={["required"]} value={name} placeholder="Name" name="name" maxLength="50" errorMessages={"Customer group name is required"} onChange={onChange} />
                                            </div>
{!getId &&
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                                <span style={span_cbox}>Limit</span>

                                                <TextValidator className="form-control" validators={["required"]} value={formData.account.accountDetails[0].limit} placeholder="Enter Limit" name="limit" onInput={validateNumbersOnly} errorMessages={"limit is required"} onChange={onChange} />
                                            </div>
}

                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mt-4">
                                                <div
                                                    className="person"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <p
                                                        className="voucher"
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            marginBottom: "0",
                                                            color: "black",
                                                        }}
                                                    >
                                                        Status
                                                    </p>
                                                    <div className="">
                                                        <label className="toggle">
                                                            <input
                                                                type="checkbox"
                                                                name="status"
                                                                checked={status}
                                                                onChange={handleToggle}
                                                            />
                                                            <span className="slider"></span>
                                                            <span
                                                                className="labels"
                                                                data-on="Active"
                                                                data-off="Inactive"
                                                            ></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mt-4">
                                                <div
                                                    className="person"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <p
                                                        className="voucher"
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            marginBottom: "0",
                                                            color: "black",
                                                        }}
                                                    >
                                                        Is Test
                                                    </p>
                                                    <div className="">
                                                        <label className="toggle">
                                                            <input
                                                                type="checkbox"
                                                                name="isTest"
                                                                checked={isTest}
                                                                onChange={handleToggle}
                                                            />
                                                            <span className="slider"></span>
                                                            <span
                                                                className="labels"
                                                                data-on="Live Sponser"
                                                                data-off="Test Sponser"
                                                            ></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mt-4">
                                                <div
                                                    className="person"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <p
                                                        className="voucher"
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            marginBottom: "0",
                                                            color: "black",
                                                        }}
                                                    >
                                                        Is Sponser Limit
                                                    </p>
                                                    <div className="">
                                                        <label className="toggle">
                                                            <input
                                                                type="checkbox"
                                                                name="isSponsorLimitChecked"
                                                                checked={isSponsorLimitChecked}
                                                                onChange={handleToggle}
                                                            />
                                                            <span className="slider"></span>
                                                            <span
                                                                className="labels"
                                                                data-on="Active"
                                                                data-off="Inactive"
                                                            ></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>




                                        </div>
                                        <div className='customer_group_form'>
                                            {getId ? (
                                                <button type='submit' className="btn btn-primary">
                                                    Update
                                                </button>
                                            ) : (
                                                <button type='submit' className="btn btn-primary ">
                                                    Create
                                                </button>
                                            )}

                                        </div>
                                        {formData?.account?.accountDetails?.length > 0 ? (
                      <div className="table-responsive mt-2">
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Limit</th>
                              <th>Used</th>
                              <th>Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData?.account?.accountDetails &&
                              formData?.account?.accountDetails.length > 0 &&
                              formData?.account?.accountDetails
                               
                                .map((transaction, i) => (
                                  <tr key={i}>
                                    <td>{transaction?.type}</td>

                                    <td>
                                    {transaction?.limit}
                                    </td>
                                    <td>
                                    {transaction?.used}
                                    </td>
                                    <td>
                                    {transaction?.balance}
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                       
                      </div>
                    ) : (
                    null
                    )}
                                    </div>
                              
                                </div>
                            </ValidatorForm>
                          
                       

                        </div>
                    </div></div>
            </div>
        </div>
    )
}

export default CreateSponser

